import { Entry } from '@/@types/entries';
import { PrintLayout } from '@/@types/print';
import {
  Header,
  POS_PRINT_BOLD_FONT_WEIGHT,
  POS_PRINT_FONT_FAMILY,
  POS_PRINT_80MM_FONT_WEIGHT,
  POS_PRINT_RENDERING_STYLES,
  Separator,
} from '@/components/common/PosPrint';
import { PrintInfoSimple } from '@/components/common/PosPrint/PrintInfoSimple';
import { PRINT_LAYOUT_1, PRINT_LAYOUT_2 } from '@/modules/utils/print-layouts';
import React from 'react';

interface IEntryPrintProps {
  entry?: Entry;
  containerRef: any | null;
  selectedLayout?: PrintLayout;
}

export function EntryPrintSimple({
  entry,
  containerRef,
  selectedLayout = PRINT_LAYOUT_1,
}: IEntryPrintProps) {
  return (
    <div
      ref={containerRef}
      style={{
        printColorAdjust: 'economy',
        width: '7.2cm',
        color: 'black',
        padding: '0.25cm',
        fontFamily: POS_PRINT_FONT_FAMILY,
        fontSize: '11px',
        fontWeight: POS_PRINT_80MM_FONT_WEIGHT,
        ...POS_PRINT_RENDERING_STYLES,
      }}
    >
      <Separator />
      <Header />
      <Header
        title={`${entry?.operation?.number || ''} - ${
          entry?.operation?.name || ''
        }`}
      />
      <Separator />
      <PrintInfoSimple
        number={entry?.number}
        date={entry?.issueDate}
        staff={entry?.staff}
        note={entry?.note}
        selectedLayout={selectedLayout}
      />
      <Separator />
      <div
        style={{
          fontWeight: POS_PRINT_BOLD_FONT_WEIGHT,
          paddingLeft: selectedLayout === PRINT_LAYOUT_2 ? '0.25cm' : '0',
        }}
      >
        PRODUTOS
      </div>
      <Separator />
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
        }}
      >
        <tbody>
          {entry?.products?.map((product, index) => (
            <tr
              key={product.id}
              style={{
                borderBottom:
                  index + 1 < entry?.products?.length
                    ? '1px solid #333333'
                    : '',
              }}
            >
              <td
                style={{
                  paddingLeft:
                    selectedLayout === PRINT_LAYOUT_2 ? '0.25cm' : '0',
                }}
              >
                {product.entryProduct.name}
              </td>
              <td
                style={{
                  textAlign: 'right',
                }}
              >
                {product.productQuantity.toFixed(2)}{' '}
                {product.entryUnit.abbreviation}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Separator />
      <br />
      <div
        style={{ textAlign: 'center', marginTop: '16px', marginBottom: '24px' }}
      >
        <p>________________________________</p>
        <p>{entry?.user.name}</p>
      </div>
      <br />
    </div>
  );
}
